import React from 'react'
import { InfoContainer, InfoWrapper, InfoRow, Column1,TopLine, TextWrapper, Boldtitle, Heading, Subtitle, Column2, ImgWrap, Img } from './InfoElements'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import "../InfoSection/styles.css"
import { useTranslation } from 'react-i18next';

import  SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'

SwiperCore.use([Pagination, Navigation, Autoplay]);

function InfoSection({lightBg, imgStart, lightText,  darkText,
  img, id, alt, img2, img3}) {

	const {t} = useTranslation();
  return (
		<>
		<InfoContainer lightBg={lightBg} id={id}>
			<InfoWrapper>
      <Swiper slidesPerView={1} spaceBetween={30} loop={true}
        pagination={{'clickable':true}} autoplay={{"delay": 3000}}>
        <SwiperSlide>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <Heading lightText={lightText}>{t("info.headline")}</Heading>
                <Subtitle darkText={darkText} >{t("info.description")}</Subtitle>		
                <Boldtitle>{t("info.bolddes")}</Boldtitle>	
                <TopLine>{t("info.topLine")}</TopLine>			
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                <Img src={ img } alt={alt} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </SwiperSlide>
        <SwiperSlide>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <Heading lightText={lightText}>{t("info.headline")}</Heading>
                <Subtitle darkText={darkText} >{t("info.description3")}</Subtitle>		
                <Boldtitle>{t("info.bolddes3")}</Boldtitle>	
                <TopLine>{t("info.topLine3")}</TopLine>			
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                <Img src={ img3 } alt={alt} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </SwiperSlide>
        <SwiperSlide>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <Heading lightText={lightText}>{t("info.headline")}</Heading>
                <Subtitle darkText={darkText} >{t("info.description2")}</Subtitle>		
                <Boldtitle>{t("info.bolddes2")}</Boldtitle>	
                <TopLine>{t("info.topLine2")}</TopLine>			
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                <Img src={ img2 } alt={alt} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </SwiperSlide>
      </Swiper>
        
			</InfoWrapper>
		</InfoContainer>	
		</>
	)
}

export default InfoSection
